export const USER_PROFILE_UPLOAD_ENDPOINT = '/adminUser/uploadImage';

export const mergeUploadedProfileImages = (profileList = [], uploadedImages = []) => {
    if (!profileList?.length || profileList[0] === 'userPhoto/default.jpg') {
        return [...uploadedImages];
    }

    return [...profileList, ...uploadedImages];
};
